import { useCallback } from 'react';
import { Box, Text, Toggle } from '@nimbus-ds/components';
import { AddressingConfigurationRuleResponseDto } from '@tiendanube/common';
import { Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import { ADDRESSING_RULES_TYPES, AddressingRuleType } from '../../constants';
import RuleSelector from '../RuleSelector/RuleSelector';

interface AppRuleBoxProps {
  rules: AddressingConfigurationRuleResponseDto[];
  handleChangeRule: (
    value: boolean,
    type: AddressingRuleType,
    appCode?: string,
  ) => void;
}

function AppRuleBox({ rules, handleChangeRule }: Readonly<AppRuleBoxProps>) {
  const t = useTranslationShipping(
    'deliveryMethods.addressingConfigurationV2.info',
  );

  const isChecked = rules.some((rule) => rule.enabled);

  const handleToggle = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        handleChangeRule(true, ADDRESSING_RULES_TYPES.APP, rules[0].code);
      } else {
        rules.forEach((rule) => {
          handleChangeRule(false, ADDRESSING_RULES_TYPES.APP, rule.code);
        });
      }
    },
    [rules, handleChangeRule],
  );

  return (
    <Box
      borderRadius="2"
      borderColor="neutral-surfaceDisabled"
      padding="4"
      borderWidth="2"
      borderStyle="solid"
      backgroundColor={isChecked ? 'transparent' : 'neutral-surface'}
    >
      <Stack spacing="tight" justify="space-between" align="flex-start">
        <Stack spacing="tight" column align="flex-start">
          <Text color="neutral-textHigh" fontWeight="bold">
            {t('appRule.editing')}
          </Text>
          <Text>{t('appRule.description')}</Text>
          <RuleSelector
            rules={rules}
            type="app"
            handleChangeRule={handleChangeRule}
            isDisabled={!isChecked}
          />
        </Stack>
        <Toggle
          name="appRuleToggle"
          checked={isChecked}
          onChange={handleToggle}
        />
      </Stack>
    </Box>
  );
}

export default AppRuleBox;
